import { render } from "./EnrolledStudents.vue?vue&type=template&id=a37570f6&ts=true"
import script from "./EnrolledStudents.vue?vue&type=script&lang=ts"
export * from "./EnrolledStudents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__